export enum ClaimReviewRequiredUpdateType {
  Payee = 'payee',
  ProNumber = 'proNumber',
  ClaimRequestAmount = 'claimRequestAmount',
  SvcCenterChargeabilityAllocation = 'svcCenterChargeabilityAllocation',
  PaymentGreaterThanLiability = 'paymentGreaterThanLiability',
  PayoutAmount = 'payoutAmount',
}
